import { theme } from 'lib';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import {
  AddMobileShoutout,
  Button,
  Col,
  ComingSoon,
  FollowRequiredModal,
  Modal,
  Row,
  Text
} from 'components';
import { PaymentModal } from './../../../../Subscribe/screens/UserList/components';

const Interactions = ({
  user,
  isCurrentUser,
  following,
  follow,
  unfollow,
  handleGetApp,
  isSubscribed,
  subscribe,
  updateOtherUser,
  unsubscribe,
  subSettingsVisible,
  setSubSettingsVisible,
  playedSports,
  onHandleShoutout,
  hasSubscriptionPlans,
  onShoutoutPosted
}) => {
  const [isShoutoutModalVisible, setIsShoutoutModalVisible] = useState(false);
  const [paymentModalVisible, setPaymentModalVisible] = useState(false);
  const isMobile = useSelector((state) => state.appState.isMobile);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const currentUser = useSelector((state) => state.user);
  const { cards } = currentUser?.billing || { cards: [] };
  const isFan = user?.type === 'fan';

  const [isComingSoonVisible, setIsComingSoonVisible] = useState(false);
  const [isAlreadySubscribedVisible, setIsAlreadySubscribedVisible] = useState(false);
  const [isFollowRequiredVisible, setIsFollowRequiredVisible] = useState(false);
  const [followRequiredFeature, setFollowRequiredFeature] = useState('');
  const [cta, setCTA] = useState('');

  // function handleMessage() {
  //   navigate(`/messages/${user._id}`);
  // }

  function handleFace2Face() {
    setCTA('face2face');
    setIsComingSoonVisible(true);

    // const isLoggedIn = onHandleTriggerFace2Face(); // will open modal for sign up for not logged in user

    // if(!isLoggedIn){
    //   return; // prevent execution code below requiring payment method, that's for logged in users
    // }

    // if(!cards?.length) {
    //   setPaymentModalVisible(true)
    //   return
    // } else {
    //   window.open('/get-the-mobile-app','_blank');
    // }
  }

  function handlePaymentModalVisible() {
    setPaymentModalVisible(!paymentModalVisible);
  }

  function requireFollowing(feature) {
    if (!following) {
      setFollowRequiredFeature(feature);
      setIsFollowRequiredVisible(true);
      return false;
    }
    return true;
  }

  function handleShoutout() {
    const isLoggedIn = onHandleShoutout(); // check if user is logged in, require sign up if so
    if (!isLoggedIn) {
      return;
    }

    if (!requireFollowing(t('common.shoutOut'))) {
      return;
    }

    setIsShoutoutModalVisible(true);
  }

  // function handleConnect() {
  //   if (isMobile) return handleGetApp();
  // }

  // if (isMobile && (isCurrentUser || isFan)) return null;

  // if(isMobile) {
  //   return (
  //     <Col wid='100%'>
  //       <Col pad='0 16px 0' wid='calc(100% - 32px)'>
  //         <Row between wid='100%' gap='16px' marg='0 0 16px'>
  //           <Button
  //             icon='shoutoutOutline'
  //             iconSize='22'
  //             text={t('common.shoutout')}
  //             bg={theme.SECONDARY}
  //             onClick={handleShoutout}
  //           />

  //           <Button
  //             text={t('common.message')}
  //             app
  //             bg={theme.SECONDARY}
  //             icon='messagesOutline'
  //             iconSize={20}
  //             onClick={handleMessage}
  //           />
  //         </Row>

  //         <Button
  //           marg='0 0 0'
  //           app
  //           bordered={currentUser}
  //           bg={currentUser ? 'transparent' : theme.SECONDARY}
  //           reverse
  //           onClick={handleConnect}
  //           text={t('profile.wantToConnect')}
  //         />
  //       </Col>
  //     </Col>
  //   )
  // }

  return (
    <>
      {/* PROFILE PAGE -------------------- */}
      {isCurrentUser ? (
        <Row center marg="2px 0 0" responsive wid={'100%'} grid>
          <Button
            text={t('profile.goToAppSettings')}
            app
            bordered
            reverse
            big
            icon="settings"
            iconSize={19.45}
            onClick={() => navigate('/settings')}
            pad="0 24px 0 20px"
            marg={!isMobile ? '0 0 0 auto' : ''}
            wid={isMobile ? '100%' : '80%'}
          />
        </Row>
      ) : (
        <Row
          wid={'100%'}
          center
          grid={!isFan}
          responsive
          gap={isMobile ? '10px' : '12px'}
          alignStart={isCurrentUser && playedSports?.length > 0 && !isMobile}
          numCols={2}
        >
          <Button
            text={following ? t('common.following') : t('common.follow')}
            app
            reverse
            bordered={following}
            bg={!following ? theme.SECONDARY : ''}
            pad="0 15.5px 0 16.5px"
            onClick={following ? unfollow : follow}
            action="follow"
            gridColSpan={1}
            icon={following ? 'doubleCheck' : ''}
            iconSize="20"
            wid={isFan ? '50%' : '100%'}
            marg={isFan && !isMobile ? '0 0 0 auto' : ''}
          />

          {!isFan && (
            <>
              {/* SUBSCRIBE */}
              <Button
                text={t(isSubscribed ? 'common.subscribed' : 'common.subscribe')}
                icon={isSubscribed && 'subscribedCheck'}
                onClick={isSubscribed ? () => setIsAlreadySubscribedVisible(true) : subscribe}
                app
                reverse
                bordered={isSubscribed}
                bg={!isSubscribed ? theme.SECONDARY : ''}
                pad="0 20.5px 0 21.5px"
                iconSize="20"
                disabled={!hasSubscriptionPlans}
              />

              {/* FACE2FACE */}
              <Button
                text={'Face2Face'}
                onClick={() => handleFace2Face()}
                app
                bg={theme.SECONDARY}
                pad="0 20.5px 0 21.5px"
                iconSize={22}
              />

              {/* SHOUTOUT */}
              <Button
                text={t('common.shoutOut')}
                app
                bg={theme.SECONDARY}
                pad="0 20.5px 0 21.5px"
                icon="shoutoutOutline"
                iconSize={22}
                onClick={() => {
                  handleShoutout();
                }}
              />

              {/* AdPlayaz */}
              <Button
                text={'AdPlayaz'}
                app
                bg={theme.SECONDARY}
                pad="0 20.5px 0 21.5px"
                iconSize={22}
                onClick={() => {
                  setCTA('adPlayaz');
                  setIsComingSoonVisible(true);
                }}
                gridColSpan={2}
              />

              {/* Conditional rendering of modals */}
              <AddMobileShoutout
                userData={user}
                visible={isShoutoutModalVisible}
                setVisible={setIsShoutoutModalVisible}
                preSelectData={{ entity: user }}
                preSelectPage="sendShoutout"
                preSelect={1}
                onShoutoutPosted={onShoutoutPosted}
              />
            </>
          )}
        </Row>
      )}
      <PaymentModal
        visible={paymentModalVisible}
        closeModal={handlePaymentModalVisible}
        navigate={navigate}
        athleteId={null}
        athleteName={user.username}
        cta={cta}
      />

      <ComingSoon
        visible={isComingSoonVisible}
        closeModal={() => setIsComingSoonVisible(false)}
        headerText={t(`common.${cta}`)}
      />

      <FollowRequiredModal
        visible={isFollowRequiredVisible}
        onClose={() => setIsFollowRequiredVisible(false)}
        teamName={user?.name || user?.username}
        feature={followRequiredFeature}
      />

      <Modal
        visible={isAlreadySubscribedVisible}
        closeModal={() => setIsAlreadySubscribedVisible(false)}
        wid={isMobile ? '320px !important' : 'auto !important'}
      >
        <Col pad="32px 42px" center wid="100%" maxWid="400px" marg="0 auto" boxSizing="border-box">
          <Col centerAll wid="100%">
            {/* <Text h3 center>
              {t('common.subscribed')}
            </Text> */}
            <Text center marg="18px 0 0">
              {t('subscription.alreadySubscribed')}
            </Text>
          </Col>
          <Row marg="30px 0 0" display="flex" justifyContent="center">
            <Button
              big
              bg={theme.SECONDARY}
              text={t('common.okay')}
              onClick={() => setIsAlreadySubscribedVisible(false)}
            />
          </Row>
        </Col>
      </Modal>
    </>
  );
};

export default Interactions;
